module.exports = __webpack_public_path__ + "assets/img/36_1449_big.381f01ec.jpg";